import React from "react";
import { useSelector, shallowEqual } from "react-redux"
import { Form, Formik } from "formik";
import * as Yup from "yup";
import TextInput from "../../../../../../../../Common/components/text-input";
import { Button, Form as FormLayout } from "react-bootstrap";
import { useUpdateAccountMetaMutation } from "../../../../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

const Meta = props => {

	/* Get Account details from redux */
	const accountDetails = useSelector(({ selectedUser }) => {
		return selectedUser.data?.accounts.filter(acc => acc.accountId === props.match.params.accountId)[0]?.details;
	}, shallowEqual);

	const { userId, accountId, meta } = accountDetails;

	const [
		updateAccountMeta, // This is the mutation trigger
		{
			isLoading: isUpdating
		}, // This is the destructured mutation result
	] = useUpdateAccountMetaMutation()

	return (
		<div className="row">
			<div className="col-12">

				<div className="card card-custom gutter-b">
					{/* <!--begin::Header--> */}
					<div className="card-header border-0">
						{/* <!--begin::Title--> */}
						<div className="card-title pt-5">
							<h3 className="card-label">
								<span className="d-block text-dark h3 font-weight-bolder">Add Account Meta</span>
								<span className="d-block text-muted mt-2 font-size-sm">Add New User Account Metadata</span>
							</h3>
						</div>
					</div>
					{/* <!--end::Header--> */}
					{/* <!--begin::Body--> */}
					<div className="card-body">
						<Formik
							initialValues={{ key: "", value: "" }}
							enableReinitialize
							validationSchema={Yup.object({
								key: Yup.string().required("Required"),
								value: Yup.string().required("Required"),
							})}
							onSubmit={(values, { resetForm }) => {
								updateAccountMeta({ userId, accountId, fields: { [values.key]: values.value }, meta })
									.unwrap()
									.then(() => {
										resetForm()
										cogoToast.success("Created 'Update Account Meta' Action SuccessFully")
									})
							}}
						>
							{({ isValid, dirty }) => (
								<Form>
									<FormLayout.Row>
										<TextInput
											label="Key*"
											name="key"
											type="text"
										/>
										<TextInput
											label="Value*"
											name="value"
											type="text"
										/>
									</FormLayout.Row>
									{dirty && <Button type="submit" disabled={!isValid || isUpdating} variant="dark" className="w-100">Add</Button>}
								</Form>
							)}
						</Formik>
					</div>
					{/* <!--end::Body--> */}
				</div>

				<div className="card card-custom gutter-b">
					{/* <!--begin::Header--> */}
					<div className="card-header border-0">
						{/* <!--begin::Title--> */}
						<div className="card-title pt-5">
							<h3 className="card-label">
								<span className="d-block text-dark h3 font-weight-bolder">Account Meta</span>
								<span className="d-block text-muted mt-2 font-size-sm">User Account Metadata</span>
							</h3>
						</div>
					</div>
					{/* <!--end::Header--> */}
					{/* <!--begin::Body--> */}
					<div className="card-body">
						<Formik
							initialValues={meta}
							enableReinitialize
							onSubmit={(values, { resetForm }) => {
								updateAccountMeta({ userId, accountId, fields: values, meta })
									.unwrap()
									.then(() => {
										resetForm()
										cogoToast.success("Created 'Update Account Meta' Action SuccessFully")
									})
							}}

						>
							{({ isValid, dirty }) => (
								<Form>
									{
										Object.keys(meta)?.map((key, i) => (
											<FormLayout.Row key={i}>
												<TextInput
													disabled
													name={`${key}`}
													type="text"
													value={key}
												/>
												<TextInput
													name={`${key}`}
													type="text"
												/>
											</FormLayout.Row>
										))
									}
									{dirty && <Button type="submit" disabled={!isValid || isUpdating} variant="dark" className="w-100">Update</Button>}
								</Form>
							)}
						</Formik>
					</div>
					{/* <!--end::Body--> */}
				</div>

			</div>
		</div>
	)
}

export default Meta;